<div>
    <br>
    <div style="width: auto; overflow: auto">
        <app-common-list-table [request]="getRequest" [cols]="cols" [filtering]="filter"
            [globalVisualTransform]="globalVisualTransform" [globalConditionalStyle]="globalConditionalStyle"
            [customExportCsv]="showTareasBioExportCsv" [actionButtonText]="canAddTareas ? btnAnadir : ''"
            (emitSearchText)="updateFooter()" (actionButtonClick)="add()" (visualize)="show('info', $event)"
            (edit)="edit($event)" (duplicate)="duplicate($event)" (remove)="show('delete', $event)">
            <ng-template #header>

                <div class="d-flex gap-4 flex-row align-self-end m-0 text-black">
                    <div *ngIf="(this.appName === 'ava' || this.appName === 'detorres')" class="d-flex flex-column justify-content-center align-content-center p-0 m-0">
                        <label>
                            {{this.appName === 'detorres' ? 'Realizados' : 'Aplicados' }}
                        </label>
                        <p-selectbutton [options]="optionsSelectButton" optionLabel="label" optionValue="value"
                            (onChange)="filtrar()" [formControl]="realizadoControl" aria-labelledby="basic">
                        </p-selectbutton>
                    </div>
                    <div *ngIf="this.rolUser ==='responsable' || this.appName === 'benibal'" style="margin-left: 20px;">
                        <button class="mx-2 btn" (click)="downloadCsv()"
                            style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white;">
                            <i class="fa fa-download"></i>
                            Exportar listado
                        </button>
                    </div>
                    <div *ngIf="showCampaign" id="campaign">
                        <label for="">Campaña</label>
                        <p-select [options]="years" optionLabel="label" optionValue="value" [formControl]="selectedYearsControl"
                            (onChange)='selectedCampaign()'></p-select>
                    </div>
                    <div style="margin-left: 20px; display: flex;" *ngIf="betweenDates">
                        <div style="display: inline-flex; align-items: center;">
                            <p style="color: white; margin-left: 10px; margin-right: 10px; margin-bottom: 0;">F. Inicio
                            </p>
                            <app-datepicker (sendFecha)="getFechaInicio($event)"></app-datepicker>
                        </div>
                        <div style="display: inline-flex; align-items: center; margin-left: 20px;">
                            <p style="color: white; margin-left: 10px; margin-right: 10px; margin-bottom: 0;">F. Fin</p>
                            <app-datepicker (sendFecha)="getFechaFin($event)"></app-datepicker>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #thEnd>
                <th class="actions">
                    <p class="mb-0 d-flex justify-content-center">Acciones</p>
                </th>
            </ng-template>

            <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
                <td class="actions">
                    <div class="ab-wrap">
                        <app-action-buttons
                            [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                            [showDuplicate]="canDuplicateTareas"
                            (duplicateRowButtonEvent)="duplicate(data.data)" (editRowButtonEvent)="edit(data.data)"
                            (deleteRowButtonEvent)="show('delete', data.data)"
                            (showRowButtonEvent)="show('info', data.data)">
                        </app-action-buttons>
                        <button *ngIf="showPrescripcion" class="d-flex justify-content-center align-items-center"
                            tooltipPosition="left" pTooltip="Generar receta" (click)="generarReceta(data.data)" style="
                                min-height: 20px;
                                min-width: 20px;
                                border: none;
                                border-radius: 3px;
                                background-color: #007b00;
                                color: white;
                                cursor: pointer;
                                margin-left: 10px;
                                ">
                            <i class="fa fa-file-pdf-o"></i>
                        </button>
                    </div>
                </td>
            </ng-template>
            <ng-template #footer let-col *ngIf="['fotoagricultura'].includes(this.appName)">
                <div style="font-size: 0.75em; text-align: left" *ngIf="(['id'].includes(col.field))">
                    TOTAL:
                </div>
                <div *ngIf="(['horas'].includes(col.field))"
                    style="font-size: 0.75em; text-align: center; font-weight: bold; padding-right: 34px">
                    {{this.totalHoras || 0}}
                </div>


            </ng-template>

        </app-common-list-table>
    </div>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serveUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

<!-- VERSIÓN "AgroGEST" -->
<p-dialog *ngIf="showRecetaAgrogest" header="Impreso de la receta" [(visible)]="showReceta" (onShow)="scrollToTop()">

    <div *ngIf="receta" id="html2canvasDiv" class="registroDiv mx-auto" style="width: 800px;">
        <div class="mb-4 text-left">
            <img *ngIf="appName === 'agrogest'" src="./assets/logo_agrogest.png" style="width: 150px; height: auto;"
                alt="Logo AgroGEST" />
            <img *ngIf="appName === 'buitech'" src="./assets/logo_buitech.png" style="width: 150px; height: auto;"
                alt="Logo buitech" />
        </div>

        <h6>General</h6>
        <table class="table table-bordered table-striped table-hover table-receta">
            <thead>
                <th>Finca</th>
                <th>Sector(es)</th>
                <th>Parcela(s)</th>
                <th>Fecha</th>
                <th>Coste total</th>
            </thead>
            <tbody>
                <tr>
                    <td>{{receta.finca}}</td>
                    <td>{{receta.sector}}</td>
                    <td>{{receta.parcelas}}</td>
                    <td>{{receta.fecha}}</td>
                    <td>{{receta.coste || '-'}} €</td>
                </tr>
            </tbody>
        </table>

        <h6>Tarea</h6>
        <table class="table table-bordered table-striped table-hover table-receta">
            <thead>
                <th>Tipo</th>
                <th *ngIf="showTareasOtrasProducto">Producto</th>
                <th *ngIf="showTareasOtrasCantidad">Cantidad</th>
            </thead>
            <tbody>
                <tr>
                    <td>{{receta.tarea}}</td>
                    <td *ngIf="showTareasOtrasProducto">{{receta.producto}}</td>
                    <td *ngIf="showTareasOtrasCantidad">{{receta.cantidad || '-'}}</td>
                </tr>
            </tbody>
        </table>

        <h6>Aplicadores</h6>
        <table class="table table-bordered table-striped table-hover table-receta">
            <thead>
                <th>Maquinaria</th>
                <th>Trabajadores</th>
                <th>Horas</th>
            </thead>
            <tbody>
                <tr>
                    <td>{{receta.maquinaria}}</td>
                    <td>{{receta.trabajadores_nombres}}</td>
                    <td>{{receta.horas_totales|| '-'}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="d-flex justify-content-center">
        <button class="btn btn-dark mx-2" (click)="showReceta = false;">Cerrar</button>
        <button class="btn btn-primary mx-2" (click)="imprimirReceta();">Imprimir</button>
        <button *ngIf="showEnviarCorreo" [disabled]="tareasApi.enviarRecetaCaptura.isLoading" (click)="enviarCorreo()"
            class="btn mx-2" [ngClass]="tareasApi.enviarRecetaCaptura.hasError ? 'btn-danger' : 'btn-warning'">

            <ng-container *ngIf="!tareasApi.enviarRecetaCaptura.isLoading && !tareasApi.enviarRecetaCaptura.hasError">
                <i class="fa fa-envelope"></i>
                Enviar Correo
            </ng-container>
            <ng-container *ngIf="tareasApi.enviarRecetaCaptura.isLoading && !tareasApi.enviarRecetaCaptura.hasError">
                <i class="fa fa-envelope"></i>
                Enviando...
            </ng-container>
            <ng-container *ngIf="tareasApi.enviarRecetaCaptura.hasError">
                <i class="fa fa-exclamation-triangle"></i>
                {{tareasApi.enviarReceta['error']}}
            </ng-container>
        </button>
    </div>

</p-dialog>

<a href="#" id="downloadReceta" style="visibility: hidden; position: fixed;"></a>